// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* PostViewerModal.css */

.pv-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, .72);

    z-index: 999999;

    display: flex;
    align-items: center;
    justify-content: center;

    padding: 20px;
}

.pv-modal {
    width: min(1450px, 96vw);
    height: min(92vh, 1000px);

    background: white;

    border-radius: 18px;

    overflow: hidden;

    display: grid;
    grid-template-columns: 62% 38%;

    position: relative;
}

/* CLOSE */

.pv-close {
    position: absolute;
    top: 18px;
    right: 18px;

    width: 42px;
    height: 42px;

    border: none;
    border-radius: 50%;

    background: rgba(0, 0, 0, .45);
    color: white;

    cursor: pointer;

    z-index: 20;
}

/* LEFT */

.pv-left {
    background: black;

    display: flex;
    align-items: center;
    justify-content: center;

    overflow: hidden;
}

.pv-media {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

/* RIGHT */

.pv-right {
    display: flex;
    flex-direction: column;

    background: white;

    border-left: 1px solid #eee;

    min-height: 0;
}

/* HEADER */

.pv-header {
    height: 74px;

    display: flex;
    align-items: center;

    padding: 0 18px;

    border-bottom: 1px solid #eee;

    flex-shrink: 0;
}

.pv-user {
    display: flex;
    align-items: center;
    gap: 12px;
}

.pv-avatar {
    width: 42px;
    height: 42px;

    border-radius: 50%;
    object-fit: cover;
}

.pv-user-info {
    display: flex;
    flex-direction: column;
}

.pv-user-info span {
    font-size: 12px;
    color: #777;
}

/* CAPTION */

.pv-caption{

    display:flex;
    gap:12px;

    padding:16px 18px;

    border-bottom:1px solid #eee;

    flex-shrink:0;

}

.pv-caption:not(.expanded){
    max-height:160px;
    overflow:hidden;
}

.pv-caption.expanded{
    max-height:35vh;
    overflow-y:auto;
}

.pv-caption-avatar {
    width: 34px;
    height: 34px;

    border-radius: 50%;
    object-fit: cover;
}

.pv-caption-content{

    flex:1 1;
    min-width:0;

    display:flex;
    flex-direction:column;

}

.pv-caption-content p {
    margin-top: 4px;
    line-height: 1.5;

    white-space: pre-wrap;
    word-break: break-word;

    /* overflow-y:auto;

    white-space:pre-wrap;
    word-break:break-word;

    padding-right:6px; */
}


.pv-caption-text p.collapsed {

    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;

    overflow: hidden;

}

.caption-scroll{

    max-height:90px;

    overflow-y:auto;

    padding-right:6px;

}

.caption-scroll::-webkit-scrollbar{

    width:6px;

}

.caption-scroll::-webkit-scrollbar-thumb{

    background:#d3d3d3;

    border-radius:20px;

}

.pv-caption-text p.expanded {
    display: block;

    max-height: 250px;
    overflow-y: auto;

    white-space: pre-wrap;
    word-break: break-word;

    padding-right: 6px;

}

.pv-see-more {

    margin-top: 8px;

    align-self: flex-start;

    border: none;
    background: none;

    color: var(--primary-100);

    cursor: pointer;

    font-weight: 600;

}

.pv-caption-text {
    display: flex;
    flex-direction: column;
}

/* COMMENTS */

.pv-comments-section {
    flex: 1 1;
    min-height: 0;

    overflow: hidden;

    display: flex;
    flex-direction: column;
}

/* IMPORTANT */

.viewer-comments-wrapper {
    flex: 1 1;
    min-height: 0;

    display: flex;
    flex-direction: column;
}

.viewer-comment-panel {
    flex: 1 1;

    display: flex;
    flex-direction: column;

    min-height: 0;
}

.viewer-comment-panel .comment-header {
    display: none;
}

.viewer-comment-panel .comment-list {
    flex: 1 1;

    min-height: 0;

    overflow-y: auto;
    overflow-x: hidden;

    padding: 18px;

    scroll-behavior: smooth;

    overscroll-behavior: contain;
}

.viewer-comment-panel .comment-input {
    border-top: 1px solid #eee;

    padding: 12px;

    background: white;

    display: flex;
    gap: 10px;
}

.viewer-comment-panel .comment-input input {
    flex: 1 1;

    border: none;
    outline: none;

    font-size: 16px;
}

.viewer-comment-panel .comment-input button {
    border: none;
    background: none;

    color: var(--primary-100);
    font-weight: 600;

    cursor: pointer;
}

/* ACTIONS */

.pv-actions {
    border-top: 1px solid #eee;

    padding: 14px 18px;

    flex-shrink: 0;
}

.pv-actions-top {
    display: flex;
    align-items: center;
    gap: 14px;

    margin-bottom: 10px;
}

.pv-action-btn {
    border: none;
    background: none;

    font-size: 24px;

    cursor: pointer;

    color: #111;

    display: flex;
    align-items: center;
    justify-content: center;

    transition: .18s ease;
}

/* .pv-action-btn {
    border: none;
    background: none;

    font-size: 24px;

    cursor: pointer;
} */

/* .pv-action-btn.liked{
    color:#ff3040 !important;
} */

.pv-stats {
    font-size: 14px;
}

/* MOBILE */

@media(max-width:900px) {

    .pv-overlay {
        padding: 0;
    }

    .pv-modal {
        width: 100vw;
        height: 100vh;

        border-radius: 0;

        display: flex;
        flex-direction: column;
    }

    .pv-left {
        flex: 1 1;
        min-height: 0;
    }

    .pv-right {
        height: 55%;
        border-left: none;
    }

    .pv-media {
        object-fit: contain;
    }

    .pv-close {
        top: 12px;
        right: 12px;
    }

}


.comment-item {
    transition: .18s ease;
}

.comment-item:hover {
    background: #fafafa;
}


.comment-list::-webkit-scrollbar {
    width: 6px;
}

.comment-list::-webkit-scrollbar-thumb {
    background: #d1d1d1;
    border-radius: 20px;
}


.pv-modal {
    animation: viewerIn .22s ease;
}

@keyframes viewerIn {
    from {
        opacity: 0;
        transform: scale(.96);
    }

    to {
        opacity: 1;
        transform: scale(1);
    }
}


.pv-action-btn.active {
    color: var(--primary-100);
}


.pv-owner-actions {
    /* position: absolute; */
    top: 20px;
    right: 60px;
    z-index: 10;
}

.pv-menu-btn {
    background: none;
    border: none;
    cursor: pointer;
    font-size: 18px;
}

.pv-dropdown {
    position: absolute;
    /* top: 35px; */
    right: 20%;
    bottom: 35px;
    background: white;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 5px 20px rgba(0, 0, 0, .15);
}

.pv-dropdown button {
    display: block;
    width: 100%;
    padding: 10px 18px;
    border: none;
    background: none;
    cursor: pointer;
    text-align: left;
}

.pv-dropdown .delete {
    color: red;
}




.pv-action-modal-overlay {
    position: fixed;
    inset: 0;
    padding: 18px;
    background: rgba(20, 43, 61, .5);
    backdrop-filter: blur(8px);
    display: flex;
    align-items: flex-end;
    z-index: 99999;
    animation: pv-action-fade-in .2s ease-out;
}

.pv-action-modal {
    position: relative;
    width: min(100%, 510px);
    margin: 0 auto;
    overflow: hidden;
    padding: 18px;
    border: 1px solid rgba(148, 169, 186, .35);
    border-bottom: 0;
    border-radius: 22px 22px 0 0;
    background: #fbfcfd;
    box-shadow: 0 -18px 52px rgba(11, 33, 49, .22), inset 0 1px #ffffff;
    animation: pv-action-sheet-in .3s cubic-bezier(.2, .8, .2, 1);
}

.pv-action-modal::before {
    position: absolute;
    top: 0;
    right: 22px;
    left: 22px;
    height: 3px;
    content: "";
    border-radius: 0 0 999px 999px;
    background: #e95a13;
}

.pv-action-handle {
    width: 38px;
    height: 4px;
    margin: auto;
    margin-bottom: 16px;
    border-radius: 999px;
    background: #c9d8e1;
}

.pv-modal-action {
    width: 100%;
    min-height: 56px;
    margin-bottom: 8px;
    padding: 11px 14px;
    color: #29475e;
    border: 1px solid #dce7ed;
    border-radius: 13px;
    background: #ffffff;
    font-size: .82rem;
    font-weight: 800;
    cursor: pointer;
    text-align: left;
    display: flex;
    align-items: center;
    gap: 11px;
    transition: transform .2s ease, border-color .2s ease, background-color .2s ease, box-shadow .2s ease;
}

.pv-modal-action > svg {
    box-sizing: content-box;
    padding: 9px;
    color: #4e7799;
    border: 1px solid #dce8ee;
    border-radius: 10px;
    background: #f1f6f9;
    font-size: .83rem;
}

.pv-modal-action:hover {
    border-color: #b9d0df;
    background: #f8fcfe;
    box-shadow: 0 9px 18px rgba(30, 63, 88, .08);
    transform: translateX(3px);
}

.pv-modal-action.delete {
    color: #c8491b;
    border-color: #ffd8c5;
    background: #fffaf7;
}

.pv-modal-action.delete > svg {
    color: #e95a13;
    border-color: #ffd6c0;
    background: #fff0e8;
}

.pv-modal-action.delete:hover {
    border-color: #f1b99b;
    background: #fff5ef;
}

.pv-modal-cancel {
    width: 100%;
    min-height: 48px;
    margin-top: 3px;
    padding: 12px;
    color: #55748e;
    border: 1px solid #dce7ed;
    border-radius: 12px;
    background: #f6fafc;
    font-size: .78rem;
    font-weight: 800;
    cursor: pointer;
    transition: .2s ease;
}

.pv-modal-cancel:hover {
    color: #29475e;
    border-color: #b9d0df;
    background: #edf5f9;
}

@keyframes pv-action-sheet-in {
    from { opacity: 0; transform: translateY(100%); }
    to { opacity: 1; transform: translateY(0); }
}

@keyframes pv-action-fade-in {
    from { opacity: 0; }
    to { opacity: 1; }
}

/* Post editor — premium CarrerUp workspace. */
.pv-edit-post-overlay {
    z-index: 100000;
    padding: 20px;
    background: rgba(20, 43, 61, .56);
    backdrop-filter: blur(10px);
}

.pv-edit-post-modal {
    position: relative;
    box-sizing: border-box;
    width: min(100%, 560px) !important;
    max-height: min(88svh, 740px);
    overflow: auto;
    padding: 25px !important;
    border: 1px solid rgba(148, 169, 186, .4);
    border-radius: 20px !important;
    background: #fbfcfd !important;
    box-shadow: 0 28px 72px rgba(10, 29, 45, .32), inset 0 1px #ffffff;
    animation: pv-edit-modal-in .24s cubic-bezier(.2, .8, .2, 1);
}

.pv-edit-post-modal::before {
    position: absolute;
    top: 0;
    right: 30px;
    left: 30px;
    height: 3px;
    content: "";
    border-radius: 0 0 999px 999px;
    background: #e95a13;
}

.pv-edit-post-modal h3 {
    margin: 3px 0 18px !important;
    color: #1d394f;
    font-size: 1.12rem;
    font-weight: 850;
    letter-spacing: -.02em;
}

.pv-edit-post-modal .edit-textarea {
    box-sizing: border-box;
    width: 100%;
    min-height: 142px;
    margin: 0 0 14px;
    padding: 14px;
    resize: vertical;
    color: #29475e;
    border: 1px solid #d7e4eb;
    border-radius: 14px;
    outline: 0;
    background: #f7fafb;
    font-family: inherit;
    font-size: .88rem;
    line-height: 1.55;
    transition: .2s ease;
}

.pv-edit-post-modal .edit-textarea:focus {
    border-color: #e95a13;
    background: #ffffff;
    box-shadow: 0 0 0 4px rgba(233, 90, 19, .1);
}

.pv-edit-post-modal .edit-preview-image,
.pv-edit-post-modal .edit-preview-video {
    display: block;
    width: 100%;
    max-height: 260px;
    margin: 0 0 14px;
    overflow: hidden;
    border: 1px solid #d7e4eb;
    border-radius: 14px;
    background: #eef4f6;
    object-fit: cover;
}

.pv-edit-post-modal .edit-preview-video video {
    display: block;
    width: 100%;
    max-height: 260px;
    background: #172d3d;
}

.pv-edit-post-modal .modal-actions {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 9px;
    margin-top: 2px;
    padding-top: 14px;
    border-top: 1px solid #e2ebf0;
}

.pv-edit-post-modal .modal-actions button {
    min-height: 44px;
    padding: 10px 14px;
    border-radius: 11px;
    font-size: .79rem;
    font-weight: 850;
    cursor: pointer;
    transition: .2s ease;
}

.pv-edit-post-modal .modal-actions .cancel {
    color: #4e7799;
    border: 1px solid #d7e4eb;
    background: #f2f7f9;
}

.pv-edit-post-modal .modal-actions .cancel:hover {
    color: #29475e;
    border-color: #b9d0df;
    background: #e8f1f5;
}

.pv-edit-post-modal .modal-actions .publish {
    color: #ffffff;
    border: 1px solid #e95a13;
    background: #e95a13;
    box-shadow: 0 9px 18px rgba(233, 90, 19, .2);
}

.pv-edit-post-modal .modal-actions .publish:hover {
    border-color: #d84f0d;
    background: #d84f0d;
    transform: translateY(-1px);
}

@keyframes pv-edit-modal-in {
    from { opacity: 0; transform: translateY(12px) scale(.98); }
    to { opacity: 1; transform: translateY(0) scale(1); }
}

/* Post viewer — CarrerUp premium high-tech reading surface. */
.pv-overlay {
    padding: 28px;
    background: rgba(20, 43, 61, .58);
    backdrop-filter: blur(12px);
}

.pv-modal {
    width: min(1240px, 94vw);
    height: min(86vh, 880px);
    grid-template-columns: minmax(0, 1.08fr) minmax(360px, .92fr);
    border: 1px solid rgba(148, 169, 186, .4);
    border-radius: 22px;
    background: #fbfcfd;
    box-shadow: 0 30px 78px rgba(8, 27, 43, .36), inset 0 1px #ffffff;
    animation: pv-carrerup-in .24s ease-out;
}

.pv-left {
    padding: 16px;
    background: #172d3d;
}

.pv-media {
    border-radius: 13px;
}

.pv-right {
    border-left: 1px solid #dce7ed;
    background: #fbfcfd;
}

.pv-close {
    top: 16px;
    right: 16px;
    width: 36px;
    height: 36px;
    border: 1px solid rgba(148, 169, 186, .42);
    border-radius: 11px;
    color: #4e7799;
    background: #f5f8fa;
    box-shadow: 0 5px 14px rgba(14, 42, 61, .12);
}

.pv-close:hover { color: #e95a13; background: #fff3ec; border-color: #ffc9aa; }

.pv-caption {
    gap: 10px;
    padding: 16px 18px 14px;
    border-bottom-color: #e2ebef;
}

.pv-caption-avatar {
    width: 36px;
    height: 36px;
    border: 2px solid #ffffff;
    box-shadow: 0 3px 10px rgba(30, 63, 88, .12);
}

.pv-caption-content strong { color: #1d394f; font-size: .86rem; font-weight: 850; }
.pv-caption-content p { color: #345269; font-size: .81rem; line-height: 1.55; }
.pv-see-more { color: #e95a13; font-size: .72rem; }

.viewer-comment-panel .comment-list {
    padding: 12px 16px;
    background: #fbfcfd;
}

.viewer-comment-panel .comment-input {
    padding: 11px 13px;
    border-top-color: #e2ebef;
    background: #ffffff;
}

.viewer-comment-panel .comment-input input {
    padding: 9px 11px;
    border: 1px solid #dce7ed;
    border-radius: 10px;
    color: #29475e;
    background: #f3f7f9;
    font-size: .78rem;
}

.viewer-comment-panel .comment-input button { color: #e95a13; font-size: .75rem; font-weight: 850; }

.pv-actions {
    padding: 12px 17px 14px;
    border-top-color: #e2ebef;
    background: #ffffff;
}

.pv-actions-top { gap: 8px; margin-bottom: 7px; }

.pv-action-btn {
    width: 36px;
    height: 36px;
    border: 1px solid #dce7ed;
    border-radius: 10px;
    color: #4e7799;
    background: #f5f8fa;
    font-size: .98rem;
}

.pv-action-btn:hover,
.pv-action-btn.active { color: #e95a13; background: #fff3ec; border-color: #ffc9aa; }
.pv-stats { color: #71899b; font-size: .73rem; }
.pv-stats strong { color: #29475e; }

.pv-owner-actions { top: 14px; right: 59px; }
.pv-menu-btn { width: 34px; height: 34px; border: 1px solid #dce7ed; border-radius: 10px; color: #4e7799; background: #f5f8fa; transition: .2s ease; }
.pv-menu-btn:hover { color: #e95a13; border-color: #ffd2bb; background: #fff3ec; transform: translateY(-1px); }

@keyframes pv-carrerup-in {
    from { opacity: 0; transform: translateY(12px) scale(.985); }
    to { opacity: 1; transform: translateY(0) scale(1); }
}

@media (max-width: 768px) {
    .pv-edit-post-overlay {
        align-items: flex-end;
        padding: 0;
    }

    .pv-edit-post-modal {
        width: 100% !important;
        max-height: min(78svh, 680px);
        padding: 22px 16px calc(18px + env(safe-area-inset-bottom)) !important;
        border-right: 0;
        border-bottom: 0;
        border-left: 0;
        border-radius: 20px 20px 0 0 !important;
    }

    .pv-edit-post-modal::before {
        right: 20px;
        left: 20px;
    }

    .pv-overlay {
        padding: 0;
        align-items: stretch;
        background: #172d3d;
        backdrop-filter: none;
    }

    .pv-modal {
        width: 100vw;
        height: 100svh;
        display: grid;
        grid-template-columns: 1fr;
        grid-template-rows: minmax(0, 42svh) minmax(0, 58svh);
        border: 0;
        border-radius: 0;
        box-shadow: none;
    }

    .pv-left { padding: 0; min-height: 0; }
    .pv-media { border-radius: 0; }

    .pv-right {
        min-height: 0;
        height: auto;
        border-top: 1px solid #dce7ed;
        border-left: 0;
    }

    .pv-close {
        top: max(12px, env(safe-area-inset-top));
        right: 12px;
        width: 34px;
        height: 34px;
        z-index: 25;
    }

    .pv-caption { max-height: 128px; padding: 12px 14px 10px; }
    .pv-caption:not(.expanded) { max-height: 128px; }
    .pv-caption-avatar { width: 33px; height: 33px; }
    .pv-caption-content p { margin-top: 2px; font-size: .76rem; line-height: 1.42; }
    .pv-caption-text p.collapsed { -webkit-line-clamp: 2; }
    .caption-scroll { max-height: 64px; }

    .pv-comments-section,
    .viewer-comments-wrapper,
    .viewer-comment-panel { min-height: 0; }

    .viewer-comment-panel .comment-list { padding: 9px 12px; }
    .viewer-comment-panel .comment-input { padding: 9px 11px calc(9px + env(safe-area-inset-bottom)); }
    .viewer-comment-panel .comment-input input { min-width: 0; padding: 8px 9px; font-size: .74rem; }

    .pv-actions { padding: 9px 12px 10px; }
    .pv-action-btn { width: 34px; height: 34px; }
    .pv-stats { font-size: .7rem; }
    .pv-owner-actions { top: 9px; right: 52px; }
}

/* Final mobile viewer layout: comfortable on mobile web and native safe areas. */
@media (max-width: 768px) {
    .pv-overlay {
        box-sizing: border-box;
        align-items: center;
        padding:
            calc(env(safe-area-inset-top, 0px) + 8px)
            max(8px, env(safe-area-inset-right, 0px))
            calc(env(safe-area-inset-bottom, 0px) + 8px)
            max(8px, env(safe-area-inset-left, 0px));
        background: rgba(12, 29, 42, .78);
        backdrop-filter: blur(8px);
    }

    .pv-modal {
        box-sizing: border-box;
        width: 100%;
        height: 100%;
        max-width: 620px;
        max-height: none;
        grid-template-rows: minmax(210px, 40%) minmax(0, 60%);
        overflow: hidden;
        border: 1px solid rgba(220, 231, 237, .68);
        border-radius: 18px;
        background: #fbfcfd;
        box-shadow: 0 18px 48px rgba(5, 19, 30, .32);
    }

    .pv-left {
        min-height: 0;
        padding: 6px;
        background: #112737;
    }

    .pv-media {
        display: block;
        width: 100%;
        height: 100%;
        border-radius: 13px 13px 8px 8px;
        object-fit: contain;
    }

    .pv-right {
        min-width: 0;
        min-height: 0;
        height: 100%;
        overflow: hidden;
        border-top: 1px solid #dce7ed;
        border-left: 0;
    }

    .pv-close {
        top: 14px;
        right: 14px;
        width: 36px;
        height: 36px;
        border-color: rgba(255, 255, 255, .35);
        color: #ffffff;
        background: rgba(12, 29, 42, .72);
        box-shadow: 0 5px 16px rgba(0, 0, 0, .22);
    }

    .pv-caption {
        gap: 9px;
        max-height: 112px;
        padding: 11px 12px 9px;
    }

    .pv-caption:not(.expanded) {
        max-height: 112px;
    }

    .pv-caption.expanded {
        max-height: min(25dvh, 190px);
    }

    .pv-caption-avatar {
        width: 32px;
        height: 32px;
    }

    .pv-caption-content strong {
        font-size: .8rem;
    }

    .pv-caption-content p {
        margin: 2px 0 0;
        font-size: .74rem;
        line-height: 1.38;
    }

    .caption-scroll {
        max-height: 66px;
    }

    .pv-see-more {
        margin-top: 4px;
        font-size: .68rem;
    }

    .viewer-comment-panel .comment-list {
        padding: 8px 10px;
        scroll-padding-block: 10px;
    }

    .viewer-comment-panel .comment-input {
        flex: 0 0 auto;
        align-items: center;
        gap: 7px;
        padding: 8px 10px;
    }

    .viewer-comment-panel .comment-input input {
        min-height: 38px;
        padding: 7px 10px;
        font-size: 16px;
    }

    .viewer-comment-panel .comment-input button {
        min-height: 38px;
        padding: 0 4px;
    }

    .pv-actions {
        padding: 8px 10px 9px;
    }

    .pv-actions-top {
        min-height: 34px;
        margin-bottom: 5px;
    }

    .pv-action-btn,
    .pv-menu-btn {
        width: 34px;
        height: 34px;
    }

    .pv-owner-actions {
        top: 8px;
        right: 48px;
    }
}

@media (max-width: 768px) and (max-height: 700px) {
    .pv-modal {
        grid-template-rows: minmax(170px, 35%) minmax(0, 65%);
    }

    .pv-caption,
    .pv-caption:not(.expanded) {
        max-height: 92px;
        padding-block: 8px;
    }

    .pv-caption-text p.collapsed {
        -webkit-line-clamp: 1;
    }
}

@media (max-width: 900px) and (orientation: landscape) {
    .pv-overlay {
        padding:
            max(6px, env(safe-area-inset-top, 0px))
            max(8px, env(safe-area-inset-right, 0px))
            max(6px, env(safe-area-inset-bottom, 0px))
            max(8px, env(safe-area-inset-left, 0px));
    }

    .pv-modal {
        width: 100%;
        height: 100%;
        max-width: none;
        display: grid;
        grid-template-columns: minmax(0, 56%) minmax(300px, 44%);
        grid-template-rows: 1fr;
        border-radius: 16px;
    }

    .pv-right {
        border-top: 0;
        border-left: 1px solid #dce7ed;
    }
}

html.native-app.native-keyboard-open .pv-overlay {
    box-sizing: border-box;
    padding: 4px 8px !important;
}

html.native-app.native-keyboard-open .pv-modal {
    height: calc(100% - 8px) !important;
}
`, "",{"version":3,"sources":["webpack://./src/componentsL/PostViewerModal.css"],"names":[],"mappings":"AAAA,wBAAwB;;AAExB;IACI,eAAe;IACf,QAAQ;IACR,8BAA8B;;IAE9B,eAAe;;IAEf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;;IAEvB,aAAa;AACjB;;AAEA;IACI,wBAAwB;IACxB,yBAAyB;;IAEzB,iBAAiB;;IAEjB,mBAAmB;;IAEnB,gBAAgB;;IAEhB,aAAa;IACb,8BAA8B;;IAE9B,kBAAkB;AACtB;;AAEA,UAAU;;AAEV;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;;IAEX,WAAW;IACX,YAAY;;IAEZ,YAAY;IACZ,kBAAkB;;IAElB,8BAA8B;IAC9B,YAAY;;IAEZ,eAAe;;IAEf,WAAW;AACf;;AAEA,SAAS;;AAET;IACI,iBAAiB;;IAEjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;;IAEvB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA,UAAU;;AAEV;IACI,aAAa;IACb,sBAAsB;;IAEtB,iBAAiB;;IAEjB,2BAA2B;;IAE3B,aAAa;AACjB;;AAEA,WAAW;;AAEX;IACI,YAAY;;IAEZ,aAAa;IACb,mBAAmB;;IAEnB,eAAe;;IAEf,6BAA6B;;IAE7B,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;;IAEZ,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA,YAAY;;AAEZ;;IAEI,YAAY;IACZ,QAAQ;;IAER,iBAAiB;;IAEjB,4BAA4B;;IAE5B,aAAa;;AAEjB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;;IAEZ,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;;IAEI,QAAM;IACN,WAAW;;IAEX,YAAY;IACZ,qBAAqB;;AAEzB;;AAEA;IACI,eAAe;IACf,gBAAgB;;IAEhB,qBAAqB;IACrB,sBAAsB;;IAEtB;;;;;wBAKoB;AACxB;;;AAGA;;IAEI,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;;IAE5B,gBAAgB;;AAEpB;;AAEA;;IAEI,eAAe;;IAEf,eAAe;;IAEf,iBAAiB;;AAErB;;AAEA;;IAEI,SAAS;;AAEb;;AAEA;;IAEI,kBAAkB;;IAElB,kBAAkB;;AAEtB;;AAEA;IACI,cAAc;;IAEd,iBAAiB;IACjB,gBAAgB;;IAEhB,qBAAqB;IACrB,sBAAsB;;IAEtB,kBAAkB;;AAEtB;;AAEA;;IAEI,eAAe;;IAEf,sBAAsB;;IAEtB,YAAY;IACZ,gBAAgB;;IAEhB,yBAAyB;;IAEzB,eAAe;;IAEf,gBAAgB;;AAEpB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA,aAAa;;AAEb;IACI,SAAO;IACP,aAAa;;IAEb,gBAAgB;;IAEhB,aAAa;IACb,sBAAsB;AAC1B;;AAEA,cAAc;;AAEd;IACI,SAAO;IACP,aAAa;;IAEb,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,SAAO;;IAEP,aAAa;IACb,sBAAsB;;IAEtB,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,SAAO;;IAEP,aAAa;;IAEb,gBAAgB;IAChB,kBAAkB;;IAElB,aAAa;;IAEb,uBAAuB;;IAEvB,4BAA4B;AAChC;;AAEA;IACI,0BAA0B;;IAE1B,aAAa;;IAEb,iBAAiB;;IAEjB,aAAa;IACb,SAAS;AACb;;AAEA;IACI,SAAO;;IAEP,YAAY;IACZ,aAAa;;IAEb,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,gBAAgB;;IAEhB,yBAAyB;IACzB,gBAAgB;;IAEhB,eAAe;AACnB;;AAEA,YAAY;;AAEZ;IACI,0BAA0B;;IAE1B,kBAAkB;;IAElB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;;IAET,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,gBAAgB;;IAEhB,eAAe;;IAEf,eAAe;;IAEf,WAAW;;IAEX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;;IAEvB,qBAAqB;AACzB;;AAEA;;;;;;;GAOG;;AAEH;;GAEG;;AAEH;IACI,eAAe;AACnB;;AAEA,WAAW;;AAEX;;IAEI;QACI,UAAU;IACd;;IAEA;QACI,YAAY;QACZ,aAAa;;QAEb,gBAAgB;;QAEhB,aAAa;QACb,sBAAsB;IAC1B;;IAEA;QACI,SAAO;QACP,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,iBAAiB;IACrB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,SAAS;QACT,WAAW;IACf;;AAEJ;;;AAGA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;;AAGA;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;;AAGA;IACI,6BAA6B;AACjC;;AAEA;IACI;QACI,UAAU;QACV,qBAAqB;IACzB;;IAEA;QACI,UAAU;QACV,mBAAmB;IACvB;AACJ;;;AAGA;IACI,yBAAyB;AAC7B;;;AAGA;IACI,wBAAwB;IACxB,SAAS;IACT,WAAW;IACX,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,UAAU;IACV,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,yCAAyC;AAC7C;;AAEA;IACI,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;;;;AAKA;IACI,eAAe;IACf,QAAQ;IACR,aAAa;IACb,gCAAgC;IAChC,0BAA0B;IAC1B,aAAa;IACb,qBAAqB;IACrB,cAAc;IACd,yCAAyC;AAC7C;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,cAAc;IACd,gBAAgB;IAChB,aAAa;IACb,0CAA0C;IAC1C,gBAAgB;IAChB,4BAA4B;IAC5B,mBAAmB;IACnB,mEAAmE;IACnE,6DAA6D;AACjE;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,UAAU;IACV,WAAW;IACX,WAAW;IACX,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,qGAAqG;AACzG;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,cAAc;IACd,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,4CAA4C;IAC5C,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,cAAc;IACd,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,OAAO,UAAU,EAAE,2BAA2B,EAAE;IAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;IACI,OAAO,UAAU,EAAE;IACnB,KAAK,UAAU,EAAE;AACrB;;AAEA,8CAA8C;AAC9C;IACI,eAAe;IACf,aAAa;IACb,iCAAiC;IACjC,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,kCAAkC;IAClC,6BAA6B;IAC7B,cAAc;IACd,wBAAwB;IACxB,yCAAyC;IACzC,8BAA8B;IAC9B,8BAA8B;IAC9B,kEAAkE;IAClE,4DAA4D;AAChE;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,UAAU;IACV,WAAW;IACX,WAAW;IACX,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,mBAAmB;IACnB,UAAU;IACV,mBAAmB;IACnB,oBAAoB;IACpB,iBAAiB;IACjB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,2CAA2C;AAC/C;;AAEA;;IAEI,cAAc;IACd,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,QAAQ;IACR,eAAe;IACf,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,mBAAmB;IACnB,4CAA4C;AAChD;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,OAAO,UAAU,EAAE,sCAAsC,EAAE;IAC3D,KAAK,UAAU,EAAE,iCAAiC,EAAE;AACxD;;AAEA,8DAA8D;AAC9D;IACI,aAAa;IACb,iCAAiC;IACjC,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;IACxB,wBAAwB;IACxB,6DAA6D;IAC7D,yCAAyC;IACzC,mBAAmB;IACnB,mBAAmB;IACnB,iEAAiE;IACjE,uCAAuC;AAC3C;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,WAAW;IACX,WAAW;IACX,YAAY;IACZ,0CAA0C;IAC1C,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB,4CAA4C;AAChD;;AAEA,kBAAkB,cAAc,EAAE,mBAAmB,EAAE,qBAAqB,EAAE;;AAE9E;IACI,SAAS;IACT,uBAAuB;IACvB,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,4CAA4C;AAChD;;AAEA,6BAA6B,cAAc,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;AAClF,wBAAwB,cAAc,EAAE,iBAAiB,EAAE,iBAAiB,EAAE;AAC9E,eAAe,cAAc,EAAE,iBAAiB,EAAE;;AAElD;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA,8CAA8C,cAAc,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;;AAEnG;IACI,uBAAuB;IACvB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA,kBAAkB,QAAQ,EAAE,kBAAkB,EAAE;;AAEhD;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;wBACwB,cAAc,EAAE,mBAAmB,EAAE,qBAAqB,EAAE;AACpF,YAAY,cAAc,EAAE,iBAAiB,EAAE;AAC/C,mBAAmB,cAAc,EAAE;;AAEnC,oBAAoB,SAAS,EAAE,WAAW,EAAE;AAC5C,eAAe,WAAW,EAAE,YAAY,EAAE,yBAAyB,EAAE,mBAAmB,EAAE,cAAc,EAAE,mBAAmB,EAAE,oBAAoB,EAAE;AACrJ,qBAAqB,cAAc,EAAE,qBAAqB,EAAE,mBAAmB,EAAE,2BAA2B,EAAE;;AAE9G;IACI,OAAO,UAAU,EAAE,uCAAuC,EAAE;IAC5D,KAAK,UAAU,EAAE,iCAAiC,EAAE;AACxD;;AAEA;IACI;QACI,qBAAqB;QACrB,UAAU;IACd;;IAEA;QACI,sBAAsB;QACtB,6BAA6B;QAC7B,sEAAsE;QACtE,eAAe;QACf,gBAAgB;QAChB,cAAc;QACd,uCAAuC;IAC3C;;IAEA;QACI,WAAW;QACX,UAAU;IACd;;IAEA;QACI,UAAU;QACV,oBAAoB;QACpB,mBAAmB;QACnB,qBAAqB;IACzB;;IAEA;QACI,YAAY;QACZ,cAAc;QACd,aAAa;QACb,0BAA0B;QAC1B,qDAAqD;QACrD,SAAS;QACT,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA,WAAW,UAAU,EAAE,aAAa,EAAE;IACtC,YAAY,gBAAgB,EAAE;;IAE9B;QACI,aAAa;QACb,YAAY;QACZ,6BAA6B;QAC7B,cAAc;IAClB;;IAEA;QACI,wCAAwC;QACxC,WAAW;QACX,WAAW;QACX,YAAY;QACZ,WAAW;IACf;;IAEA,cAAc,iBAAiB,EAAE,uBAAuB,EAAE;IAC1D,6BAA6B,iBAAiB,EAAE;IAChD,qBAAqB,WAAW,EAAE,YAAY,EAAE;IAChD,wBAAwB,eAAe,EAAE,iBAAiB,EAAE,iBAAiB,EAAE;IAC/E,+BAA+B,qBAAqB,EAAE;IACtD,kBAAkB,gBAAgB,EAAE;;IAEpC;;4BAEwB,aAAa,EAAE;;IAEvC,sCAAsC,iBAAiB,EAAE;IACzD,uCAAuC,yDAAyD,EAAE;IAClG,6CAA6C,YAAY,EAAE,gBAAgB,EAAE,iBAAiB,EAAE;;IAEhG,cAAc,sBAAsB,EAAE;IACtC,iBAAiB,WAAW,EAAE,YAAY,EAAE;IAC5C,YAAY,gBAAgB,EAAE;IAC9B,oBAAoB,QAAQ,EAAE,WAAW,EAAE;AAC/C;;AAEA,iFAAiF;AACjF;IACI;QACI,sBAAsB;QACtB,mBAAmB;QACnB;;;;oDAI4C;QAC5C,iCAAiC;QACjC,0BAA0B;IAC9B;;IAEA;QACI,sBAAsB;QACtB,WAAW;QACX,YAAY;QACZ,gBAAgB;QAChB,gBAAgB;QAChB,qDAAqD;QACrD,gBAAgB;QAChB,0CAA0C;QAC1C,mBAAmB;QACnB,mBAAmB;QACnB,4CAA4C;IAChD;;IAEA;QACI,aAAa;QACb,YAAY;QACZ,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,WAAW;QACX,YAAY;QACZ,gCAAgC;QAChC,mBAAmB;IACvB;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,YAAY;QACZ,gBAAgB;QAChB,6BAA6B;QAC7B,cAAc;IAClB;;IAEA;QACI,SAAS;QACT,WAAW;QACX,WAAW;QACX,YAAY;QACZ,sCAAsC;QACtC,cAAc;QACd,iCAAiC;QACjC,yCAAyC;IAC7C;;IAEA;QACI,QAAQ;QACR,iBAAiB;QACjB,sBAAsB;IAC1B;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;QACjB,0BAA0B;IAC9B;;IAEA;QACI,cAAc;QACd,mBAAmB;QACnB,QAAQ;QACR,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,gBAAgB;QAChB,cAAc;IAClB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;;QAEI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,QAAQ;QACR,WAAW;IACf;AACJ;;AAEA;IACI;QACI,qDAAqD;IACzD;;IAEA;;QAEI,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,qBAAqB;IACzB;AACJ;;AAEA;IACI;QACI;;;;oDAI4C;IAChD;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,eAAe;QACf,aAAa;QACb,wDAAwD;QACxD,uBAAuB;QACvB,mBAAmB;IACvB;;IAEA;QACI,aAAa;QACb,8BAA8B;IAClC;AACJ;;AAEA;IACI,sBAAsB;IACtB,2BAA2B;AAC/B;;AAEA;IACI,mCAAmC;AACvC","sourcesContent":["/* PostViewerModal.css */\n\n.pv-overlay {\n    position: fixed;\n    inset: 0;\n    background: rgba(0, 0, 0, .72);\n\n    z-index: 999999;\n\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    padding: 20px;\n}\n\n.pv-modal {\n    width: min(1450px, 96vw);\n    height: min(92vh, 1000px);\n\n    background: white;\n\n    border-radius: 18px;\n\n    overflow: hidden;\n\n    display: grid;\n    grid-template-columns: 62% 38%;\n\n    position: relative;\n}\n\n/* CLOSE */\n\n.pv-close {\n    position: absolute;\n    top: 18px;\n    right: 18px;\n\n    width: 42px;\n    height: 42px;\n\n    border: none;\n    border-radius: 50%;\n\n    background: rgba(0, 0, 0, .45);\n    color: white;\n\n    cursor: pointer;\n\n    z-index: 20;\n}\n\n/* LEFT */\n\n.pv-left {\n    background: black;\n\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    overflow: hidden;\n}\n\n.pv-media {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n}\n\n/* RIGHT */\n\n.pv-right {\n    display: flex;\n    flex-direction: column;\n\n    background: white;\n\n    border-left: 1px solid #eee;\n\n    min-height: 0;\n}\n\n/* HEADER */\n\n.pv-header {\n    height: 74px;\n\n    display: flex;\n    align-items: center;\n\n    padding: 0 18px;\n\n    border-bottom: 1px solid #eee;\n\n    flex-shrink: 0;\n}\n\n.pv-user {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n\n.pv-avatar {\n    width: 42px;\n    height: 42px;\n\n    border-radius: 50%;\n    object-fit: cover;\n}\n\n.pv-user-info {\n    display: flex;\n    flex-direction: column;\n}\n\n.pv-user-info span {\n    font-size: 12px;\n    color: #777;\n}\n\n/* CAPTION */\n\n.pv-caption{\n\n    display:flex;\n    gap:12px;\n\n    padding:16px 18px;\n\n    border-bottom:1px solid #eee;\n\n    flex-shrink:0;\n\n}\n\n.pv-caption:not(.expanded){\n    max-height:160px;\n    overflow:hidden;\n}\n\n.pv-caption.expanded{\n    max-height:35vh;\n    overflow-y:auto;\n}\n\n.pv-caption-avatar {\n    width: 34px;\n    height: 34px;\n\n    border-radius: 50%;\n    object-fit: cover;\n}\n\n.pv-caption-content{\n\n    flex:1;\n    min-width:0;\n\n    display:flex;\n    flex-direction:column;\n\n}\n\n.pv-caption-content p {\n    margin-top: 4px;\n    line-height: 1.5;\n\n    white-space: pre-wrap;\n    word-break: break-word;\n\n    /* overflow-y:auto;\n\n    white-space:pre-wrap;\n    word-break:break-word;\n\n    padding-right:6px; */\n}\n\n\n.pv-caption-text p.collapsed {\n\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n\n    overflow: hidden;\n\n}\n\n.caption-scroll{\n\n    max-height:90px;\n\n    overflow-y:auto;\n\n    padding-right:6px;\n\n}\n\n.caption-scroll::-webkit-scrollbar{\n\n    width:6px;\n\n}\n\n.caption-scroll::-webkit-scrollbar-thumb{\n\n    background:#d3d3d3;\n\n    border-radius:20px;\n\n}\n\n.pv-caption-text p.expanded {\n    display: block;\n\n    max-height: 250px;\n    overflow-y: auto;\n\n    white-space: pre-wrap;\n    word-break: break-word;\n\n    padding-right: 6px;\n\n}\n\n.pv-see-more {\n\n    margin-top: 8px;\n\n    align-self: flex-start;\n\n    border: none;\n    background: none;\n\n    color: var(--primary-100);\n\n    cursor: pointer;\n\n    font-weight: 600;\n\n}\n\n.pv-caption-text {\n    display: flex;\n    flex-direction: column;\n}\n\n/* COMMENTS */\n\n.pv-comments-section {\n    flex: 1;\n    min-height: 0;\n\n    overflow: hidden;\n\n    display: flex;\n    flex-direction: column;\n}\n\n/* IMPORTANT */\n\n.viewer-comments-wrapper {\n    flex: 1;\n    min-height: 0;\n\n    display: flex;\n    flex-direction: column;\n}\n\n.viewer-comment-panel {\n    flex: 1;\n\n    display: flex;\n    flex-direction: column;\n\n    min-height: 0;\n}\n\n.viewer-comment-panel .comment-header {\n    display: none;\n}\n\n.viewer-comment-panel .comment-list {\n    flex: 1;\n\n    min-height: 0;\n\n    overflow-y: auto;\n    overflow-x: hidden;\n\n    padding: 18px;\n\n    scroll-behavior: smooth;\n\n    overscroll-behavior: contain;\n}\n\n.viewer-comment-panel .comment-input {\n    border-top: 1px solid #eee;\n\n    padding: 12px;\n\n    background: white;\n\n    display: flex;\n    gap: 10px;\n}\n\n.viewer-comment-panel .comment-input input {\n    flex: 1;\n\n    border: none;\n    outline: none;\n\n    font-size: 16px;\n}\n\n.viewer-comment-panel .comment-input button {\n    border: none;\n    background: none;\n\n    color: var(--primary-100);\n    font-weight: 600;\n\n    cursor: pointer;\n}\n\n/* ACTIONS */\n\n.pv-actions {\n    border-top: 1px solid #eee;\n\n    padding: 14px 18px;\n\n    flex-shrink: 0;\n}\n\n.pv-actions-top {\n    display: flex;\n    align-items: center;\n    gap: 14px;\n\n    margin-bottom: 10px;\n}\n\n.pv-action-btn {\n    border: none;\n    background: none;\n\n    font-size: 24px;\n\n    cursor: pointer;\n\n    color: #111;\n\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    transition: .18s ease;\n}\n\n/* .pv-action-btn {\n    border: none;\n    background: none;\n\n    font-size: 24px;\n\n    cursor: pointer;\n} */\n\n/* .pv-action-btn.liked{\n    color:#ff3040 !important;\n} */\n\n.pv-stats {\n    font-size: 14px;\n}\n\n/* MOBILE */\n\n@media(max-width:900px) {\n\n    .pv-overlay {\n        padding: 0;\n    }\n\n    .pv-modal {\n        width: 100vw;\n        height: 100vh;\n\n        border-radius: 0;\n\n        display: flex;\n        flex-direction: column;\n    }\n\n    .pv-left {\n        flex: 1;\n        min-height: 0;\n    }\n\n    .pv-right {\n        height: 55%;\n        border-left: none;\n    }\n\n    .pv-media {\n        object-fit: contain;\n    }\n\n    .pv-close {\n        top: 12px;\n        right: 12px;\n    }\n\n}\n\n\n.comment-item {\n    transition: .18s ease;\n}\n\n.comment-item:hover {\n    background: #fafafa;\n}\n\n\n.comment-list::-webkit-scrollbar {\n    width: 6px;\n}\n\n.comment-list::-webkit-scrollbar-thumb {\n    background: #d1d1d1;\n    border-radius: 20px;\n}\n\n\n.pv-modal {\n    animation: viewerIn .22s ease;\n}\n\n@keyframes viewerIn {\n    from {\n        opacity: 0;\n        transform: scale(.96);\n    }\n\n    to {\n        opacity: 1;\n        transform: scale(1);\n    }\n}\n\n\n.pv-action-btn.active {\n    color: var(--primary-100);\n}\n\n\n.pv-owner-actions {\n    /* position: absolute; */\n    top: 20px;\n    right: 60px;\n    z-index: 10;\n}\n\n.pv-menu-btn {\n    background: none;\n    border: none;\n    cursor: pointer;\n    font-size: 18px;\n}\n\n.pv-dropdown {\n    position: absolute;\n    /* top: 35px; */\n    right: 20%;\n    bottom: 35px;\n    background: white;\n    border-radius: 10px;\n    overflow: hidden;\n    box-shadow: 0 5px 20px rgba(0, 0, 0, .15);\n}\n\n.pv-dropdown button {\n    display: block;\n    width: 100%;\n    padding: 10px 18px;\n    border: none;\n    background: none;\n    cursor: pointer;\n    text-align: left;\n}\n\n.pv-dropdown .delete {\n    color: red;\n}\n\n\n\n\n.pv-action-modal-overlay {\n    position: fixed;\n    inset: 0;\n    padding: 18px;\n    background: rgba(20, 43, 61, .5);\n    backdrop-filter: blur(8px);\n    display: flex;\n    align-items: flex-end;\n    z-index: 99999;\n    animation: pv-action-fade-in .2s ease-out;\n}\n\n.pv-action-modal {\n    position: relative;\n    width: min(100%, 510px);\n    margin: 0 auto;\n    overflow: hidden;\n    padding: 18px;\n    border: 1px solid rgba(148, 169, 186, .35);\n    border-bottom: 0;\n    border-radius: 22px 22px 0 0;\n    background: #fbfcfd;\n    box-shadow: 0 -18px 52px rgba(11, 33, 49, .22), inset 0 1px #ffffff;\n    animation: pv-action-sheet-in .3s cubic-bezier(.2, .8, .2, 1);\n}\n\n.pv-action-modal::before {\n    position: absolute;\n    top: 0;\n    right: 22px;\n    left: 22px;\n    height: 3px;\n    content: \"\";\n    border-radius: 0 0 999px 999px;\n    background: #e95a13;\n}\n\n.pv-action-handle {\n    width: 38px;\n    height: 4px;\n    margin: auto;\n    margin-bottom: 16px;\n    border-radius: 999px;\n    background: #c9d8e1;\n}\n\n.pv-modal-action {\n    width: 100%;\n    min-height: 56px;\n    margin-bottom: 8px;\n    padding: 11px 14px;\n    color: #29475e;\n    border: 1px solid #dce7ed;\n    border-radius: 13px;\n    background: #ffffff;\n    font-size: .82rem;\n    font-weight: 800;\n    cursor: pointer;\n    text-align: left;\n    display: flex;\n    align-items: center;\n    gap: 11px;\n    transition: transform .2s ease, border-color .2s ease, background-color .2s ease, box-shadow .2s ease;\n}\n\n.pv-modal-action > svg {\n    box-sizing: content-box;\n    padding: 9px;\n    color: #4e7799;\n    border: 1px solid #dce8ee;\n    border-radius: 10px;\n    background: #f1f6f9;\n    font-size: .83rem;\n}\n\n.pv-modal-action:hover {\n    border-color: #b9d0df;\n    background: #f8fcfe;\n    box-shadow: 0 9px 18px rgba(30, 63, 88, .08);\n    transform: translateX(3px);\n}\n\n.pv-modal-action.delete {\n    color: #c8491b;\n    border-color: #ffd8c5;\n    background: #fffaf7;\n}\n\n.pv-modal-action.delete > svg {\n    color: #e95a13;\n    border-color: #ffd6c0;\n    background: #fff0e8;\n}\n\n.pv-modal-action.delete:hover {\n    border-color: #f1b99b;\n    background: #fff5ef;\n}\n\n.pv-modal-cancel {\n    width: 100%;\n    min-height: 48px;\n    margin-top: 3px;\n    padding: 12px;\n    color: #55748e;\n    border: 1px solid #dce7ed;\n    border-radius: 12px;\n    background: #f6fafc;\n    font-size: .78rem;\n    font-weight: 800;\n    cursor: pointer;\n    transition: .2s ease;\n}\n\n.pv-modal-cancel:hover {\n    color: #29475e;\n    border-color: #b9d0df;\n    background: #edf5f9;\n}\n\n@keyframes pv-action-sheet-in {\n    from { opacity: 0; transform: translateY(100%); }\n    to { opacity: 1; transform: translateY(0); }\n}\n\n@keyframes pv-action-fade-in {\n    from { opacity: 0; }\n    to { opacity: 1; }\n}\n\n/* Post editor — premium CarrerUp workspace. */\n.pv-edit-post-overlay {\n    z-index: 100000;\n    padding: 20px;\n    background: rgba(20, 43, 61, .56);\n    backdrop-filter: blur(10px);\n}\n\n.pv-edit-post-modal {\n    position: relative;\n    box-sizing: border-box;\n    width: min(100%, 560px) !important;\n    max-height: min(88svh, 740px);\n    overflow: auto;\n    padding: 25px !important;\n    border: 1px solid rgba(148, 169, 186, .4);\n    border-radius: 20px !important;\n    background: #fbfcfd !important;\n    box-shadow: 0 28px 72px rgba(10, 29, 45, .32), inset 0 1px #ffffff;\n    animation: pv-edit-modal-in .24s cubic-bezier(.2, .8, .2, 1);\n}\n\n.pv-edit-post-modal::before {\n    position: absolute;\n    top: 0;\n    right: 30px;\n    left: 30px;\n    height: 3px;\n    content: \"\";\n    border-radius: 0 0 999px 999px;\n    background: #e95a13;\n}\n\n.pv-edit-post-modal h3 {\n    margin: 3px 0 18px !important;\n    color: #1d394f;\n    font-size: 1.12rem;\n    font-weight: 850;\n    letter-spacing: -.02em;\n}\n\n.pv-edit-post-modal .edit-textarea {\n    box-sizing: border-box;\n    width: 100%;\n    min-height: 142px;\n    margin: 0 0 14px;\n    padding: 14px;\n    resize: vertical;\n    color: #29475e;\n    border: 1px solid #d7e4eb;\n    border-radius: 14px;\n    outline: 0;\n    background: #f7fafb;\n    font-family: inherit;\n    font-size: .88rem;\n    line-height: 1.55;\n    transition: .2s ease;\n}\n\n.pv-edit-post-modal .edit-textarea:focus {\n    border-color: #e95a13;\n    background: #ffffff;\n    box-shadow: 0 0 0 4px rgba(233, 90, 19, .1);\n}\n\n.pv-edit-post-modal .edit-preview-image,\n.pv-edit-post-modal .edit-preview-video {\n    display: block;\n    width: 100%;\n    max-height: 260px;\n    margin: 0 0 14px;\n    overflow: hidden;\n    border: 1px solid #d7e4eb;\n    border-radius: 14px;\n    background: #eef4f6;\n    object-fit: cover;\n}\n\n.pv-edit-post-modal .edit-preview-video video {\n    display: block;\n    width: 100%;\n    max-height: 260px;\n    background: #172d3d;\n}\n\n.pv-edit-post-modal .modal-actions {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 9px;\n    margin-top: 2px;\n    padding-top: 14px;\n    border-top: 1px solid #e2ebf0;\n}\n\n.pv-edit-post-modal .modal-actions button {\n    min-height: 44px;\n    padding: 10px 14px;\n    border-radius: 11px;\n    font-size: .79rem;\n    font-weight: 850;\n    cursor: pointer;\n    transition: .2s ease;\n}\n\n.pv-edit-post-modal .modal-actions .cancel {\n    color: #4e7799;\n    border: 1px solid #d7e4eb;\n    background: #f2f7f9;\n}\n\n.pv-edit-post-modal .modal-actions .cancel:hover {\n    color: #29475e;\n    border-color: #b9d0df;\n    background: #e8f1f5;\n}\n\n.pv-edit-post-modal .modal-actions .publish {\n    color: #ffffff;\n    border: 1px solid #e95a13;\n    background: #e95a13;\n    box-shadow: 0 9px 18px rgba(233, 90, 19, .2);\n}\n\n.pv-edit-post-modal .modal-actions .publish:hover {\n    border-color: #d84f0d;\n    background: #d84f0d;\n    transform: translateY(-1px);\n}\n\n@keyframes pv-edit-modal-in {\n    from { opacity: 0; transform: translateY(12px) scale(.98); }\n    to { opacity: 1; transform: translateY(0) scale(1); }\n}\n\n/* Post viewer — CarrerUp premium high-tech reading surface. */\n.pv-overlay {\n    padding: 28px;\n    background: rgba(20, 43, 61, .58);\n    backdrop-filter: blur(12px);\n}\n\n.pv-modal {\n    width: min(1240px, 94vw);\n    height: min(86vh, 880px);\n    grid-template-columns: minmax(0, 1.08fr) minmax(360px, .92fr);\n    border: 1px solid rgba(148, 169, 186, .4);\n    border-radius: 22px;\n    background: #fbfcfd;\n    box-shadow: 0 30px 78px rgba(8, 27, 43, .36), inset 0 1px #ffffff;\n    animation: pv-carrerup-in .24s ease-out;\n}\n\n.pv-left {\n    padding: 16px;\n    background: #172d3d;\n}\n\n.pv-media {\n    border-radius: 13px;\n}\n\n.pv-right {\n    border-left: 1px solid #dce7ed;\n    background: #fbfcfd;\n}\n\n.pv-close {\n    top: 16px;\n    right: 16px;\n    width: 36px;\n    height: 36px;\n    border: 1px solid rgba(148, 169, 186, .42);\n    border-radius: 11px;\n    color: #4e7799;\n    background: #f5f8fa;\n    box-shadow: 0 5px 14px rgba(14, 42, 61, .12);\n}\n\n.pv-close:hover { color: #e95a13; background: #fff3ec; border-color: #ffc9aa; }\n\n.pv-caption {\n    gap: 10px;\n    padding: 16px 18px 14px;\n    border-bottom-color: #e2ebef;\n}\n\n.pv-caption-avatar {\n    width: 36px;\n    height: 36px;\n    border: 2px solid #ffffff;\n    box-shadow: 0 3px 10px rgba(30, 63, 88, .12);\n}\n\n.pv-caption-content strong { color: #1d394f; font-size: .86rem; font-weight: 850; }\n.pv-caption-content p { color: #345269; font-size: .81rem; line-height: 1.55; }\n.pv-see-more { color: #e95a13; font-size: .72rem; }\n\n.viewer-comment-panel .comment-list {\n    padding: 12px 16px;\n    background: #fbfcfd;\n}\n\n.viewer-comment-panel .comment-input {\n    padding: 11px 13px;\n    border-top-color: #e2ebef;\n    background: #ffffff;\n}\n\n.viewer-comment-panel .comment-input input {\n    padding: 9px 11px;\n    border: 1px solid #dce7ed;\n    border-radius: 10px;\n    color: #29475e;\n    background: #f3f7f9;\n    font-size: .78rem;\n}\n\n.viewer-comment-panel .comment-input button { color: #e95a13; font-size: .75rem; font-weight: 850; }\n\n.pv-actions {\n    padding: 12px 17px 14px;\n    border-top-color: #e2ebef;\n    background: #ffffff;\n}\n\n.pv-actions-top { gap: 8px; margin-bottom: 7px; }\n\n.pv-action-btn {\n    width: 36px;\n    height: 36px;\n    border: 1px solid #dce7ed;\n    border-radius: 10px;\n    color: #4e7799;\n    background: #f5f8fa;\n    font-size: .98rem;\n}\n\n.pv-action-btn:hover,\n.pv-action-btn.active { color: #e95a13; background: #fff3ec; border-color: #ffc9aa; }\n.pv-stats { color: #71899b; font-size: .73rem; }\n.pv-stats strong { color: #29475e; }\n\n.pv-owner-actions { top: 14px; right: 59px; }\n.pv-menu-btn { width: 34px; height: 34px; border: 1px solid #dce7ed; border-radius: 10px; color: #4e7799; background: #f5f8fa; transition: .2s ease; }\n.pv-menu-btn:hover { color: #e95a13; border-color: #ffd2bb; background: #fff3ec; transform: translateY(-1px); }\n\n@keyframes pv-carrerup-in {\n    from { opacity: 0; transform: translateY(12px) scale(.985); }\n    to { opacity: 1; transform: translateY(0) scale(1); }\n}\n\n@media (max-width: 768px) {\n    .pv-edit-post-overlay {\n        align-items: flex-end;\n        padding: 0;\n    }\n\n    .pv-edit-post-modal {\n        width: 100% !important;\n        max-height: min(78svh, 680px);\n        padding: 22px 16px calc(18px + env(safe-area-inset-bottom)) !important;\n        border-right: 0;\n        border-bottom: 0;\n        border-left: 0;\n        border-radius: 20px 20px 0 0 !important;\n    }\n\n    .pv-edit-post-modal::before {\n        right: 20px;\n        left: 20px;\n    }\n\n    .pv-overlay {\n        padding: 0;\n        align-items: stretch;\n        background: #172d3d;\n        backdrop-filter: none;\n    }\n\n    .pv-modal {\n        width: 100vw;\n        height: 100svh;\n        display: grid;\n        grid-template-columns: 1fr;\n        grid-template-rows: minmax(0, 42svh) minmax(0, 58svh);\n        border: 0;\n        border-radius: 0;\n        box-shadow: none;\n    }\n\n    .pv-left { padding: 0; min-height: 0; }\n    .pv-media { border-radius: 0; }\n\n    .pv-right {\n        min-height: 0;\n        height: auto;\n        border-top: 1px solid #dce7ed;\n        border-left: 0;\n    }\n\n    .pv-close {\n        top: max(12px, env(safe-area-inset-top));\n        right: 12px;\n        width: 34px;\n        height: 34px;\n        z-index: 25;\n    }\n\n    .pv-caption { max-height: 128px; padding: 12px 14px 10px; }\n    .pv-caption:not(.expanded) { max-height: 128px; }\n    .pv-caption-avatar { width: 33px; height: 33px; }\n    .pv-caption-content p { margin-top: 2px; font-size: .76rem; line-height: 1.42; }\n    .pv-caption-text p.collapsed { -webkit-line-clamp: 2; }\n    .caption-scroll { max-height: 64px; }\n\n    .pv-comments-section,\n    .viewer-comments-wrapper,\n    .viewer-comment-panel { min-height: 0; }\n\n    .viewer-comment-panel .comment-list { padding: 9px 12px; }\n    .viewer-comment-panel .comment-input { padding: 9px 11px calc(9px + env(safe-area-inset-bottom)); }\n    .viewer-comment-panel .comment-input input { min-width: 0; padding: 8px 9px; font-size: .74rem; }\n\n    .pv-actions { padding: 9px 12px 10px; }\n    .pv-action-btn { width: 34px; height: 34px; }\n    .pv-stats { font-size: .7rem; }\n    .pv-owner-actions { top: 9px; right: 52px; }\n}\n\n/* Final mobile viewer layout: comfortable on mobile web and native safe areas. */\n@media (max-width: 768px) {\n    .pv-overlay {\n        box-sizing: border-box;\n        align-items: center;\n        padding:\n            calc(env(safe-area-inset-top, 0px) + 8px)\n            max(8px, env(safe-area-inset-right, 0px))\n            calc(env(safe-area-inset-bottom, 0px) + 8px)\n            max(8px, env(safe-area-inset-left, 0px));\n        background: rgba(12, 29, 42, .78);\n        backdrop-filter: blur(8px);\n    }\n\n    .pv-modal {\n        box-sizing: border-box;\n        width: 100%;\n        height: 100%;\n        max-width: 620px;\n        max-height: none;\n        grid-template-rows: minmax(210px, 40%) minmax(0, 60%);\n        overflow: hidden;\n        border: 1px solid rgba(220, 231, 237, .68);\n        border-radius: 18px;\n        background: #fbfcfd;\n        box-shadow: 0 18px 48px rgba(5, 19, 30, .32);\n    }\n\n    .pv-left {\n        min-height: 0;\n        padding: 6px;\n        background: #112737;\n    }\n\n    .pv-media {\n        display: block;\n        width: 100%;\n        height: 100%;\n        border-radius: 13px 13px 8px 8px;\n        object-fit: contain;\n    }\n\n    .pv-right {\n        min-width: 0;\n        min-height: 0;\n        height: 100%;\n        overflow: hidden;\n        border-top: 1px solid #dce7ed;\n        border-left: 0;\n    }\n\n    .pv-close {\n        top: 14px;\n        right: 14px;\n        width: 36px;\n        height: 36px;\n        border-color: rgba(255, 255, 255, .35);\n        color: #ffffff;\n        background: rgba(12, 29, 42, .72);\n        box-shadow: 0 5px 16px rgba(0, 0, 0, .22);\n    }\n\n    .pv-caption {\n        gap: 9px;\n        max-height: 112px;\n        padding: 11px 12px 9px;\n    }\n\n    .pv-caption:not(.expanded) {\n        max-height: 112px;\n    }\n\n    .pv-caption.expanded {\n        max-height: min(25dvh, 190px);\n    }\n\n    .pv-caption-avatar {\n        width: 32px;\n        height: 32px;\n    }\n\n    .pv-caption-content strong {\n        font-size: .8rem;\n    }\n\n    .pv-caption-content p {\n        margin: 2px 0 0;\n        font-size: .74rem;\n        line-height: 1.38;\n    }\n\n    .caption-scroll {\n        max-height: 66px;\n    }\n\n    .pv-see-more {\n        margin-top: 4px;\n        font-size: .68rem;\n    }\n\n    .viewer-comment-panel .comment-list {\n        padding: 8px 10px;\n        scroll-padding-block: 10px;\n    }\n\n    .viewer-comment-panel .comment-input {\n        flex: 0 0 auto;\n        align-items: center;\n        gap: 7px;\n        padding: 8px 10px;\n    }\n\n    .viewer-comment-panel .comment-input input {\n        min-height: 38px;\n        padding: 7px 10px;\n        font-size: 16px;\n    }\n\n    .viewer-comment-panel .comment-input button {\n        min-height: 38px;\n        padding: 0 4px;\n    }\n\n    .pv-actions {\n        padding: 8px 10px 9px;\n    }\n\n    .pv-actions-top {\n        min-height: 34px;\n        margin-bottom: 5px;\n    }\n\n    .pv-action-btn,\n    .pv-menu-btn {\n        width: 34px;\n        height: 34px;\n    }\n\n    .pv-owner-actions {\n        top: 8px;\n        right: 48px;\n    }\n}\n\n@media (max-width: 768px) and (max-height: 700px) {\n    .pv-modal {\n        grid-template-rows: minmax(170px, 35%) minmax(0, 65%);\n    }\n\n    .pv-caption,\n    .pv-caption:not(.expanded) {\n        max-height: 92px;\n        padding-block: 8px;\n    }\n\n    .pv-caption-text p.collapsed {\n        -webkit-line-clamp: 1;\n    }\n}\n\n@media (max-width: 900px) and (orientation: landscape) {\n    .pv-overlay {\n        padding:\n            max(6px, env(safe-area-inset-top, 0px))\n            max(8px, env(safe-area-inset-right, 0px))\n            max(6px, env(safe-area-inset-bottom, 0px))\n            max(8px, env(safe-area-inset-left, 0px));\n    }\n\n    .pv-modal {\n        width: 100%;\n        height: 100%;\n        max-width: none;\n        display: grid;\n        grid-template-columns: minmax(0, 56%) minmax(300px, 44%);\n        grid-template-rows: 1fr;\n        border-radius: 16px;\n    }\n\n    .pv-right {\n        border-top: 0;\n        border-left: 1px solid #dce7ed;\n    }\n}\n\nhtml.native-app.native-keyboard-open .pv-overlay {\n    box-sizing: border-box;\n    padding: 4px 8px !important;\n}\n\nhtml.native-app.native-keyboard-open .pv-modal {\n    height: calc(100% - 8px) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
